<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h2 class="m-0 h1 text-uppercase mb-3">Selecciona tus {{ !event.reserva_instalaciones ? footer.termino_entradas : 'reservas' }}</h2>
            </div>
            <div class="col-12 col-lg-8 mb-3 mb-lg-0">
                <transition name="fade" mode="out-in">
                    <div key="mapa-butacas" id="mapa-butacas">
                        <ContentOrLoading>
                            <div v-if="!loading" class="col-12 lightgray-content text-center p-3">
                                <LeafletComponent
                                    :plazasSeleccionadas="butacasSeleccionadas"
                                    :svgRendered="svgRendered"
                                    :originalColor="originalColor"
                                    :disabled="continuarConCompra || !preciosEnButacas || bloquearPaso"
                                    @isPanning="(e) => isPanning = e"
                                />
                            </div>
                        </ContentOrLoading>
                        <div class="alert alert-danger mt-3" v-if="error">
                            <b>
                                <template v-if="error === 'numeradas'">
                                    {{ $t('partido.error_numeradas') }}
                                </template>
                                <template v-else-if="error === 'max_asientos_superados'">
                                    {{ $t('partido.error_max_asientos_superados', { n_butacas: max_asientos }) }}
                                </template>
                                <template v-else >
                                    {{ $t('partido.error_sin_numerar') }}
                                </template>
                            </b>
                        </div>
                    </div>
                </transition>
            </div>
            <div class="col-12 col-lg-4">
                <b-row>
                    <b-col cols="12">
                        <div class="d-flex flex-column justify-content-between" :style="dynamicStyle()">
                            <div class="overflow-auto tusEntradas">
                                <div 
                                    v-for="(butaca, index) in butacasSeleccionadas"
                                    class="lightgray-content p-2 mb-2"
                                    :key="index"
                                >
                                    <div class="text-bold mb-2 d-flex justify-content-between">
                                        <div class="oswald d-flex">
                                            {{ num = index + 1 }}.&nbsp; <span v-html="getButacaName(butaca)"></span>
                                        </div>
                                        <span role="button" class="oswald" @click="clickButaca(butaca, index)">
                                            <i class="fas fa-times mr-2"></i>
                                        </span>
                                    </div>
                                    <div class="form-group mb-1">
                                        <ValidationProvider
                                            :name="'precio' + index"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                v-model="butaca.precioSeleccionado"
                                                name="precio"
                                                data-cy="selectEntradas"
                                                @change="butacasConPrecios"
                                                :disabled="bloquearPaso"
                                            >
                                                <option :value="undefined" disabled hidden>
                                                    {{ $t("partido.tipo_entrada") }}
                                                </option>
                                                <option
                                                    v-for="(precio, index) in butaca.precios"
                                                    :key="index"
                                                    :value="precio"
                                                >
                                                    {{ precio.descripcion }} / {{ precio.precio | formatear_precio }}
                                                </option>
                                            </select>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <b-row v-if="teatro.carrito_varios_eventos">
                            <template v-if="!carrito || carrito.items_count == 0">
                                <b-col cols="9">
                                    <b-button 
                                        v-if="hayButacasSeleccionadas && confValida"
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !preciosEnButacas || bloquearPaso || loadingPasoDos"
                                        @click="continuarCompra"
                                    >
                                        {{ $t('partido.continuar') }}
                                    </b-button>
                                </b-col>
                                <b-col cols="3">
                                    <b-button 
                                        v-if="hayButacasSeleccionadas && confValida" 
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !preciosEnButacas || bloquearPaso || loadingPasoDos || disableButtonCart"
                                        @click="checkCarrito()"
                                    >
                                        <i class="fa fa-cart-plus" aria-hidden="true"></i>
                                    </b-button>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col cols="12">
                                    <b-button 
                                        v-if="hayButacasSeleccionadas && confValida" 
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !preciosEnButacas || bloquearPaso || loadingPasoDos || disableButtonCart"
                                        @click="checkCarrito()"
                                    >
                                        {{ $t('carrito.añadir') }}
                                    </b-button>
                                </b-col>
                            </template>                            
                        </b-row>
                        <b-row v-else>
                            <b-col>
                                <b-button 
                                    v-if="plazasSeleccionadas.length > 0 && confValida" 
                                    class="btn btn-block mb-0"
                                    :disabled="continuarConCompra || !preciosEnButacas || bloquearPaso || loadingPasoDos"
                                    @click="continuarCompra"
                                >
                                    {{ $t('partido.continuar') }}
                                </b-button>
                            </b-col>   
                        </b-row>
                        <div 
                            v-if="hayButacasSeleccionadas && !confValida"
                            class="text-white bg-danger p-2 font-weight-bold rounded w-100 text-center"
                        >
                            ¡No puedes dejar huecos entre butacas!
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <ModalRegionSinNumerar
            v-if="showModalRegionSinNumerar && !butacasNumeradas"
            :precios="preciosSeleccionados"
            :regionSeleccionada="regionSeleccionada"
            @setAsientos="setButacas"
            @close="closeModal"
        />
    </div>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import comprobarButacasLeaflet from '@/mixins/comprobarButacasLeaflet.js';
    import ModalRegionSinNumerar from './ModalRegionSinNumerar.vue';
    import { claveVisibilidad } from '@/utils/visibilidadReducida';
    import $ from 'jquery';

    export default {
        props: {
            event: {
                type: Object,
                required: true
            },
            recinto_id: {
                type: Number,
                required: true
            },
            continuarConCompra: {
                type: Boolean,
                required: true
            },
            configuracion: {
                type: Object,
                required: true
            },
            resetButacas: {
                type: Number,
                required: true
            },
            bloquearPaso: {
                type: Boolean,
                required: false
            },
            loadingPasoDos: {
                type: Boolean,
                required: false
            },
            max_asientos: {
                type: Number,
                default: 10
            }
        },
        mixins: [comprobarButacasLeaflet],
        emits: ['continuarCompra', 'regionSeleccionada', 'setAsientos'],
        data() {
            return {
                loading: false,
                svgRendered: null,
                butacas: null,
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                ocupadaColor: 'red',
                seleccionadaColor: '#8CA9D9',
                isPanning: false,
                butacasSeleccionadas: [],
                preciosEnButacas: false,
                regiones: [],
                preciosSeleccionados: null,
                showModalRegionSinNumerar: false,
                regionSeleccionada: null,
                error: null,
                disableButtonCart: false,
                popoverListeners: new Map(),
                popoverGlobal: null,
            }
        },
        created() {
            this.init();
        },
        watch: {
            butacasSeleccionadas() {
                if (this.butacasSeleccionadas.length === 0) {
                    this.error = null;
                }
                for (let i in this.butacasSeleccionadas) {
                    if (!this.butacasSeleccionadas[i].precioSeleccionado) {
                        this.butacasSeleccionadas[i].precioSeleccionado =
                            this.butacasSeleccionadas[i].precios.length === 1 ? this.butacasSeleccionadas[i].precios[0] : null;
                    }
                }
                this.preciosEnButacas = this.butacasSeleccionadas.every(butaca => butaca.precioSeleccionado);
            },
            resetButacas() {
                this.$emit('resetContinuarConCompra');
                this.butacasSeleccionadas = [];
                this.init();
            }
        },
        computed: {
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            carrito() {
                return this.$store.getters.getCarritoActivoOnline;
            },
            load_panzoom() {
                let load_panzoom = true

                let userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if (/windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            },
            hayButacasSeleccionadas() {
                return this.butacasSeleccionadas.length > 0;
            },
            butacasSinNumerar() {
                return this.hayButacasSeleccionadas && this.butacasSeleccionadas.every(butaca => butaca.fila === 0 && butaca.butaca === 0);
            },
            butacasNumeradas() {
                return this.hayButacasSeleccionadas && this.butacasSeleccionadas.every(butaca => butaca.fila > 0 && butaca.butaca > 0);
            },
            asientosMaximosSuperados() {
                return this.butacasSeleccionadas?.length >= this.max_asientos;
            }
        },
        methods: {
            initGlobalPopover() {
                if (!this.popoverGlobal) {
                    const popoverDiv = document.createElement('div');
                    popoverDiv.id = 'global-popover';
                    popoverDiv.style.position = 'absolute';
                    popoverDiv.style.display = 'none';
                    document.body.appendChild(popoverDiv);

                    $(popoverDiv).popover({
                        trigger: 'manual',
                        html: true,
                        placement: 'auto'
                    });

                    this.popoverGlobal = popoverDiv;
                }
            },
            removePopoverListeners(element) {
                if (this.popoverListeners.has(element)) {
                    const { mouseenter, mouseleave } = this.popoverListeners.get(element);
                    element.removeEventListener('mouseenter', mouseenter);
                    element.removeEventListener('mouseleave', mouseleave);
                    this.popoverListeners.delete(element);
                }
            },
            removeAllPopoverListeners() {
                for (const [element, { mouseenter, mouseleave }] of this.popoverListeners) {
                    element.removeEventListener('mouseenter', mouseenter);
                    element.removeEventListener('mouseleave', mouseleave);
                }
                this.popoverListeners.clear();
            },
            drawPopover(element, content, title = null) {
                if (!this.load_panzoom) return;

                this.initGlobalPopover();
                this.removePopoverListeners(element);

                const mouseenter = () => {
                    const rect = element.getBoundingClientRect();
                    this.popoverGlobal.style.left = `${rect.right + 10 + window.scrollX}px`;
                    this.popoverGlobal.style.top = `${rect.top + window.scrollY}px`;
                    this.popoverGlobal.style.display = 'block';

                    this.popoverGlobal.setAttribute('data-content', content);
                    this.popoverGlobal.setAttribute('title', title || '');

                    $(this.popoverGlobal).popover('dispose');
                    $(this.popoverGlobal).popover({
                        trigger: 'manual',
                        html: true,
                        placement: 'right',
                        title: title || '',
                        content: content
                    });
                    $(this.popoverGlobal).popover('show');
                };

                const mouseleave = () => {
                    $(this.popoverGlobal).popover('hide');
                    this.popoverGlobal.style.display = 'none';
                };

                element.addEventListener('mouseenter', mouseenter);
                element.addEventListener('mouseleave', mouseleave);
                this.popoverListeners.set(element, { mouseenter, mouseleave });
            },
            async init() {
                this.loading = true;

                try {
                    const [butacasRes, regionesRes, svgRes] = await Promise.all([
                        this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.butacas'), {
                            filters: {},
                            event_id: this.$route.params.event_id,
                            sesion_id: this.$route.params.sesion_id
                        }),
                        this.$store.dispatch(this.config.getVuexAlias('front.evento.regiones.sin-asientos'), {
                            filters: { tid: this.configuracion.hash_teatro },
                            evento_id: this.$route.params.event_id,
                            sesion_id: this.$route.params.sesion_id
                        }).catch(() => ({ data: { data: [] } })),
                        this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), {
                            filters: {},
                            recinto_id: this.recinto_id
                        })
                    ]);

                    this.butacas = butacasRes.data.butacas;
                    this.$emit('setButacas', this.butacas);
                    this.setPlazasConf(this.butacas);

                    this.regiones = regionesRes.data.data;

                    this.renderLeafletSvg(svgRes.data.svg);
                } catch (e) {
                    console.error('Error al inicializar el plano de butacas', e);
                } finally {
                    this.loading = false;
                    this.$nextTick(() => {
                        this.$scrollTo('#mapa-butacas', 1000);
                    });
                }
            },

            renderLeafletSvg(svg) {
                this.removeAllPopoverListeners();

                const butacasMap = new Map(this.butacas.filter(b => b.svg_id).map(b => [b.svg_id, b]));
                const regionesMap = new Map(this.regiones.filter(r => r.svg_id).map(r => [String(r.svg_id), r]));

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;
                const svgElement = tempDiv.firstElementChild;

                const butacaNodes = svgElement.querySelectorAll('[id^="butaca"]');
                const regionNodes = svgElement.querySelectorAll('[id^="region"]');

                butacaNodes.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const butaca = butacasMap.get(svg_id);

                    if (butaca) {
                        const title = this.getButacaName(butaca);

                        if (butaca.disponible && butaca.precios.length > 0) {
                            const content = `Desde: ${this.getPrecioButaca(butaca)} €`;
                            this.drawPopover(circle, content, title);

                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s';
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
                                setTimeout(() => {
                                    if (!this.isPanning && !this.continuarConCompra) {
                                        if (!this.butacasSinNumerar) {
                                            if (!isSeleccionado && !this.asientosMaximosSuperados) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            } else {
                                                circle.setAttribute('fill', this.originalColor);
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                        }
                                        this.clickButaca(butaca);
                                    }
                                }, 150);
                            });
                        } else if (!butaca.disponible && butaca.precios.length > 0) {
                            this.drawPopover(circle, 'Ocupada', title);
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.ocupadaColor);
                            circle.style.fill = 'red';
                        } else {
                            this.drawPopover(circle, 'No disponible', title);
                            circle.setAttribute('no-disponible', 'true');
                            circle.setAttribute('fill', this.noDisponibleColor);
                        }
                    }
                });

                regionNodes.forEach(element => {
                    const svg_id = this.getButacaId(element);
                    const region = regionesMap.get(svg_id);

                    if (region) {
                        if (region.libres > 0 && region.precios.length > 0) {
                            const content = this.getRegionPrecio(region);
                            this.drawPopover(element, content, region.nombre);

                            element.style.fill = this.originalColor;
                            element.style.cursor = 'pointer';
                            element.setAttribute('pointer-events', 'all');

                            element.addEventListener('click', () => {
                                if (!this.continuarConCompra) {
                                    if (this.butacasSinNumerar || this.butacasSeleccionadas.length === 0) {
                                        this.regionSeleccionada = region;
                                        this.showModalEntradas(region.precios);
                                    } else {
                                        if (!this.butacasNumeradas) {
                                            const popover = document.querySelector('.popover');
                                            if (popover) popover.remove();
                                            this.butacas.forEach(butaca => butaca.seleccionada = false);
                                            this.butacasSeleccionadas = [];
                                        } else {
                                            this.error = 'sin_numerar';
                                        }
                                    }
                                }
                            });
                        } else if (region.libres <= 0 && region.precios.length > 0) {
                            element.style.fill = 'red';
                            element.style.cursor = 'not-allowed';
                            this.drawPopover(element, 'Entradas agotadas', region.nombre);
                        } else {
                            element.style.fill = 'gray';
                            element.style.cursor = 'not-allowed';
                            this.drawPopover(element, 'No disponible', region.nombre);
                        }
                    }
                });

                this.svgRendered = svgElement;
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!this.event.reserva_instalaciones) {
                    if (nButaca == 0  && nFila == 0) {
                        name += `Sin numerar`;
                    } else if (!nButaca && !nFila) {
                        name += `Plaza: ${butaca.numero}`;
                    } else {
                        name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                    }
                } else {
                    name += butaca.name
                }

                if (visibilidad_reducida) {
                    const nombre = this.$t(claveVisibilidad('visibilidad_reducida.nombre', this.$route?.params?.sesion_id ?? null, clave => this.$te(clave)));
                    name += '<span class="text-danger"> ' + nombre + '</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            getPrecioButaca({ precios }) {
                if (precios.length > 0) {
                    let precioMasBajo = precios.reduce((menorPrecio, precio) => {
                        return Math.min(menorPrecio, precio.precio);
                    }, Number.POSITIVE_INFINITY)

                    return Math.ceil(precioMasBajo * 100) / 100;
                }

                return 0;
            },
            clickButaca(butaca, index = null) {
                if (!this.continuarConCompra && !this.bloquearPaso) {
                    if (butaca && butaca.precios.length > 0) {
                        if (butaca.butaca === 0 && butaca.fila === 0) {
                            if (index !== -1) {
                                this.butacasSeleccionadas.splice(index, 1);
                            }
                        } else if (butaca.disponible) {
                            if (!this.butacasSinNumerar) {
                                butaca.seleccionada = butaca?.seleccionada ? false : true;
        
                                if (butaca.seleccionada) {
                                    if (!this.asientosMaximosSuperados) {
                                        if (butaca.visibilidad_reducida) {
                                            this.$modal.show('visibilidad-reducida-butaca');
                                        }
                                        this.butacasSeleccionadas.push(butaca);
                                        this.butacasSeleccionadas.sort((a, b) => a.butaca - b.butaca);
                                    } else {
                                        this.error = 'max_asientos_superados';
                                    }
                                } else {
                                    const selectedIndex = this.butacasSeleccionadas.findIndex(
                                        b => b.id === butaca.id
                                    );
                                    if (selectedIndex !== -1) {
                                        this.butacasSeleccionadas.splice(selectedIndex, 1);
                                    }
                                }
                            } else {
                                this.error = 'numeradas';
                            }
                        }
                    }
                }
            },
            checkCarrito() {
                if (this.carrito) {
                    this.setItemsCarrito();
                } else {
                    this.crearCarrito();
                }
            },
            async crearCarrito() {
                const params = { filters: {}, uuid: localStorage.getItem('uuid') };

                return this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.crear'), params).then(res => {
                    this.setItemsCarrito();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            async setItemsCarrito() {
                this.disableButtonCart = true;
            
                const params = {
                    filters: {uuid: localStorage.getItem('uuid')},
                    cart_id: this.carrito?.id,
                    plazas: this.getPlazasFormatted(),
                    asientos: []
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.add-items'), params).then(res => {
                    this.$toast.success('Entradas añadidas al carrito correctamente.');
                    this.$store.dispatch('USUARIO_CARRITO_ACTIVO', {filters:{ uuid: localStorage.getItem('uuid')}});
                    this.$router.push({path: "/eventos"});
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.disableButtonCart = false;
                });
            },
            getPlazasFormatted() {
                let plazas = [];

                this.butacasSeleccionadas.map(plaza => {
                    plazas.push({
                        precio: {
                            id: plaza.precioSeleccionado.id
                        },
                        id: plaza.id,
                        event_id:this.$route.params.event_id,
                        event_session_id: this.$route.params.sesion_id,
                        region_id: plaza.region_id
                    })
                });

                return plazas;
            },
            butacasConPrecios(e) {
                this.preciosEnButacas = this.butacasSeleccionadas.every(butaca => butaca.precioSeleccionado);
            },
            continuarCompra() {
                const tipoEmit = this.butacasSinNumerar ? 'setAsientos' : 'continuarCompra';

                this.$emit(tipoEmit, this.butacasSeleccionadas);
            },
            getRegionPrecio(region) {
                const lowestPrice = region.precios.reduce((lowest, current) => {
                    const currentPrice = parseFloat(current.precio);
                    if (!lowest || currentPrice < lowest) {
                        return currentPrice;
                    }

                    return lowest;
                }, null);

                return `Desde: ${lowestPrice}€`;
            },
            showModalEntradas(precios) {
                this.preciosSeleccionados = precios;
                this.showModalRegionSinNumerar = true;

                this.$nextTick(() => {
                    this.$modal.show('modal-region-sin-numerar');
                })
            },
            closeModal() {
                this.showModalRegionSinNumerar = false;
            },
            setButacas(butacas) {
                if (!this.butacasNumeradas) {
                    this.butacasSeleccionadas.push(...butacas);
                }
            },
            dynamicStyle() {
                const botonesVisibles = (this.hayButacasSeleccionadas && this.confValida && this.teatro.carrito_varios_eventos)
                    + (this.hayButacasSeleccionadas && this.confValida && !this.carrito);
                return {
                    height: botonesVisibles  === 1 ? '100%': '94.2%'
                }
            }
        },
        components: { LeafletComponent, ModalRegionSinNumerar }
    }
</script>

<style scoped>
@media only screen and (min-width: 768px) {
    .tusEntradas {
        height: 486px;
    }
}
</style>